document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-load-more]');
  if (!button || button.classList.contains('is-loading')) return;

  const nextUrl = button.dataset.nextUrl;
  const targetSelector = button.dataset.target;
  const targetGrid = document.querySelector(targetSelector);

  if (!nextUrl || !targetGrid) return;

  const pointerX = event.clientX;
  const pointerY = event.clientY;

  button.classList.add('is-loading');
  button.setAttribute('aria-busy', 'true');

  const resetCtaState = (el) => {
    el.classList.remove('is-loading', 'is-cta-filled', 'is-cta-settled', 'cta-snap');
    el.removeAttribute('aria-busy');
    el.style.removeProperty('--cta-x');
    el.style.removeProperty('--cta-y');
    el.style.removeProperty('--cta-size');
    el.blur();
  };

  const restoreHoverFill = (el) => {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover || typeof window.ackCtaFillIn !== 'function') return;
    const underPointer = document.elementFromPoint(pointerX, pointerY);
    if (!underPointer || !el.contains(underPointer)) return;
    window.ackCtaFillIn(el, { clientX: pointerX, clientY: pointerY });
  };

  try {
    const response = await fetch(nextUrl);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newGrid = doc.querySelector(targetSelector);
    const newItems = newGrid ? newGrid.querySelectorAll(':scope > li') : [];
    const priorityIds = new Set(
      Array.from(document.querySelectorAll('[data-priority-grid] [data-product-id]'), (item) => item.dataset.productId)
    );
    newItems.forEach((item) => {
      if (item.dataset.productId && priorityIds.has(item.dataset.productId)) return;
      targetGrid.appendChild(item);
    });

    if (window.lenis) window.lenis.resize();
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();

    const currentWrapper = button.closest('.pagination-wrapper--load-more');
    const newWrapper = doc.querySelector('.pagination-wrapper--load-more');

    if (newWrapper && currentWrapper) {
      const freshWrapper = document.importNode(newWrapper, true);
      currentWrapper.replaceWith(freshWrapper);
      const freshButton = freshWrapper.querySelector('[data-load-more]');
      if (freshButton) {
        requestAnimationFrame(() => restoreHoverFill(freshButton));
      }
    } else {
      currentWrapper?.remove();
    }
  } catch (error) {
    console.error('Load more failed:', error);
    resetCtaState(button);
  }
});
